import { Component, Input, OnChanges } from '@angular/core';
import { MatTreeModule, MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { NodeStructure } from '../models/material-common-models';
import { MaterialModule } from '../material.module';
import { MatIconModule } from '@angular/material/icon';
import { TooltipDisableDirective } from '../custom-directives/tooltip.directive';

@Component({
    selector: 'app-tree',
    templateUrl: './tree.component.html',
    imports: [MaterialModule, MatTreeModule, MatIconModule, TooltipDisableDirective],
    styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements OnChanges {
    @Input() data: NodeStructure[] = [];
    treeControl = new NestedTreeControl<NodeStructure>(node => node.Children);
    dataSource = new MatTreeNestedDataSource<NodeStructure>();

    ngOnChanges(): void {
        this.dataSource.data = this.data;

        // Expand all nodes by default
        this.treeControl.dataNodes = this.data;
        this.treeControl.expandAll();
    }

    hasChild = (_: number, node: NodeStructure) => !!node.Children && node.Children.length > 0;

    public buildTreeControlId(controlId: string, node?: NodeStructure): string {
        const nodeIdentifier = node?.Id || node?.Name || 'unknown';
        return `tree-${controlId}-${nodeIdentifier}`;
    }
}